import clsx from 'clsx'
import { type FC, type ReactNode, useState } from 'react'

type Props = {
  /** ラベル */
  label: ReactNode
  /** ラベルの truncate を無効化（多段ラベル用）。デフォルト: true */
  truncateLabel?: boolean
  /** title 属性（Ant Design ツールチップ制御用） */
  title?: string
  /** アクションボタン群（ホバー時のみ表示） */
  children?: ReactNode
}

/**
 * Select/AutoComplete の optionRender 内で使用する共通コンポーネント。
 * ホバー時にアクションボタンを表示するパターンを共通化する。
 */
export const SelectOptionWithAction: FC<Props> = ({
  label,
  truncateLabel = true,
  title,
  children
}) => {
  const [isHovered, setIsHovered] = useState(false)
  const hasChildren = !!children

  return (
    <div
      className="flex min-h-[32px] items-center justify-between gap-2"
      title={title}
      onMouseEnter={hasChildren ? () => setIsHovered(true) : undefined}
      onMouseLeave={hasChildren ? () => setIsHovered(false) : undefined}
      onFocus={hasChildren ? () => setIsHovered(true) : undefined}
      onBlur={hasChildren ? () => setIsHovered(false) : undefined}
    >
      <div className={clsx('min-w-0 flex-1', truncateLabel && 'truncate')}>
        {label}
      </div>
      {hasChildren && isHovered && children}
    </div>
  )
}
